module.exports = __webpack_public_path__ + "static/image-eefaaa482040f2792e5594f5cf6baee2.jpg";